module.exports = __webpack_public_path__ + "media/images/sf-brand-grey-f319ec8ee9f0c5288299277cf1066273.png";